// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.perxis-auto-1_16_13-markers {
  /* Typography */
  --perxis-auto-markers-more-icon-color-inner: var(--perxis-auto-markers-more-icon-color, var(--perxis-auto-root-typography-color-light-inner));
  --perxis-auto-markers-more-hover-icon-color-inner: var(--perxis-auto-markers-more-hover-icon-color, var(--perxis-auto-markers-more-icon-color-inner));
  /* End Typography */
  /* Color */
  --perxis-auto-markers-more-icon-background-color-inner: var(--perxis-auto-markers-more-icon-background-color, transparent);
  /* End Color */
  /* Border */
  --perxis-auto-markers-more-icon-border-radius-inner: var(--perxis-auto-markers-more-icon-border-radius, 0);
  /* End Borders */
  /* Margin */
  --perxis-auto-markers-margin-bottom-inner: var(--perxis-auto-markers-margin-bottom, 5px);
  --perxis-auto-markers-margin-right-inner: var(--perxis-auto-markers-margin-right, 4px);
  --perxis-auto-markers-more-icon-size-inner: var(--perxis-auto-markers-more-icon-size, 22px);
  /* End Margin */
  /* Opacity */
  --perxis-auto-markers-more-icon-opacity-inner: var(--perxis-auto-markers-more-icon-opacity, 0.5);
  --perxis-auto-markers-more-hover-icon-opacity-inner: var(--perxis-auto-markers-more-hover-icon-opacity, 1);
  /* End Opacity */
  position: relative;
  display: flex;
  flex-direction: row;
  width: 100%;
  position: relative;
}
.perxis-auto-1_16_13-markers .perxis-auto-1_16_13-markers__container {
  position: relative;
  margin-bottom: calc(-1 * var(--perxis-auto-markers-margin-bottom-inner));
  display: flex;
  flex: 1 0 0;
  overflow: hidden;
  flex-wrap: nowrap;
}
.perxis-auto-1_16_13-markers .perxis-auto-1_16_13-markers__icon-more {
  position: relative;
}
.perxis-auto-1_16_13-markers .perxis-auto-1_16_13-markers__icon-more--absolute {
  position: absolute;
  right: 0;
}
.perxis-auto-1_16_13-markers .perxis-auto-1_16_13-markers__icon-more--hidden {
  visibility: hidden;
}
.perxis-auto-1_16_13-markers .perxis-auto-1_16_13-markers__marker.ant-5_17_0-tag {
  display: block;
  margin-right: var(--perxis-auto-markers-margin-right-inner);
  margin-bottom: var(--perxis-auto-markers-margin-bottom-inner);
}
.perxis-auto-1_16_13-markers .perxis-auto-1_16_13-markers__marker.ant-5_17_0-tag .perxis-auto-1_16_13-paragraph--marker {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.perxis-auto-1_16_13-markers .perxis-auto-1_16_13-markers__marker-tooltip-trigger {
  display: inline;
}
.perxis-auto-1_16_13-markers .perxis-auto-1_16_13-markers__marker-tooltip-trigger--hidden {
  visibility: hidden;
}
.perxis-auto-1_16_13-markers .perxis-auto-1_16_13-markers__container--wrap {
  flex-wrap: wrap;
}
.perxis-auto-1_16_13-markers .perxis-auto-1_16_13-markers__container--ellipsis .perxis-auto-1_16_13-markers__marker-tooltip-trigger {
  overflow: hidden;
}
.perxis-auto-1_16_13-markers .perxis-auto-1_16_13-markers__container--ellipsis .perxis-auto-1_16_13-markers__marker-tooltip-button {
  overflow: hidden;
}
.perxis-auto-1_16_13-markers .perxis-auto-1_16_13-icon-moretags {
  --perxis-auto-icon-font-size: var(--perxis-auto-markers-more-icon-size-inner);
  color: var(--perxis-auto-markers-more-icon-color-inner);
  opacity: var(--perxis-auto-markers-more-icon-opacity-inner);
  background-color: var(--perxis-auto-markers-more-icon-background-color-inner);
  border-radius: var(--perxis-auto-markers-more-icon-border-radius-inner);
  transition: opacity 0.3s, visibility 0s linear 0.3s;
}
.perxis-auto-1_16_13-markers .ant-5_17_0-tooltip-open .perxis-auto-1_16_13-icon-moretags {
  color: var(--perxis-auto-markers-more-hover-icon-color-inner);
  opacity: var(--perxis-auto-markers-more-hover-icon-opacity-inner);
}

.perxis-auto-1_16_13-markers__more-tooltip {
  /* Typography */
  --perxis-auto-markers-more-tooltip-color-inner: var(--perxis-auto-markers-more-tooltip-color, var(--perxis-auto-root-typography-color-darkest-inner));
  /* End Typography */
  /* Colors */
  --perxis-auto-markers-more-tooltip-background-color-inner: var(--perxis-auto-markers-more-tooltip-background-color, var(--perxis-auto-root-first-color-inner));
  /* End Colors */
  /* Padding */
  --perxis-auto-markers-more-tooltip-padding-inner: var(--perxis-auto-markers-more-tooltip-padding, 18px);
  /* End Padding */
  --perxis-auto-tooltip-background-color: var(--perxis-auto-markers-more-tooltip-background-color-inner);
  --perxis-auto-tooltip-color: var(--perxis-auto-markers-more-tooltip-color-inner);
}
.perxis-auto-1_16_13-markers__more-tooltip .ant-5_17_0-tooltip-inner {
  padding: var(--perxis-auto-markers-more-tooltip-padding-inner);
}

.perxis-auto-1_16_13-markers__marker-tooltip {
  /* Typography */
  --perxis-auto-markers-marker-tooltip-font-family-inner: var(--perxis-auto-markers-marker-tooltip-font-family, var(--perxis-auto-root-typography-small-font-family-inner));
  --perxis-auto-markers-marker-tooltip-font-size-inner: var(--perxis-auto-markers-marker-tooltip-font-size, var(--perxis-auto-root-typography-small-font-size-xxl-inner));
  --perxis-auto-markers-marker-tooltip-font-weight-inner: var(--perxis-auto-markers-marker-tooltip-font-weight, var(--perxis-auto-root-typography-small-font-weight-inner));
  --perxis-auto-markers-marker-tooltip-letter-spacing-inner: var(--perxis-auto-markers-marker-tooltip-letter-spacing, var(--perxis-auto-root-typography-small-letter-spacing-inner));
  --perxis-auto-markers-marker-tooltip-line-height-inner: var(--perxis-auto-markers-marker-tooltip-line-height, var(--perxis-auto-root-typography-main-line-height-xxl-inner));
  --perxis-auto-markers-marker-tooltip-text-transform-inner: var(--perxis-auto-markers-marker-tooltip-text-transform, var(--perxis-auto-root-typography-small-text-transform-inner));
  --perxis-auto-markers-marker-tooltip-color-inner: var(--perxis-auto-markers-marker-tooltip-color, var(--perxis-auto-root-typography-color-darkest-inner));
  /* End Typography */
  --perxis-auto-typography-small-font-family: var(--perxis-auto-markers-marker-tooltip-font-family-inner);
  --perxis-auto-typography-small-font-weight: var(--perxis-auto-markers-marker-tooltip-font-weight-inner);
  --perxis-auto-typography-small-letter-spacing: var(--perxis-auto-markers-marker-tooltip-letter-spacing-inner);
  --perxis-auto-typography-small-text-transform: var(--perxis-auto-markers-marker-tooltip-text-transform-inner);
  --perxis-auto-typography-small-font-size-xxs: var(--perxis-auto-markers-marker-tooltip-font-size-inner);
  --perxis-auto-typography-small-font-size-xs: var(--perxis-auto-markers-marker-tooltip-font-size-inner);
  --perxis-auto-typography-small-font-size-sm: var(--perxis-auto-markers-marker-tooltip-font-size-inner);
  --perxis-auto-typography-small-font-size-md: var(--perxis-auto-markers-marker-tooltip-font-size-inner);
  --perxis-auto-typography-small-font-size-lg: var(--perxis-auto-markers-marker-tooltip-font-size-inner);
  --perxis-auto-typography-small-font-size-xl: var(--perxis-auto-markers-marker-tooltip-font-size-inner);
  --perxis-auto-typography-small-font-size-xxl: var(--perxis-auto-markers-marker-tooltip-font-size-inner);
  --perxis-auto-typography-small-line-height-xxs: var(--perxis-auto-markers-marker-tooltip-line-height-inner);
  --perxis-auto-typography-small-line-height-xs: var(--perxis-auto-markers-marker-tooltip-line-height-inner);
  --perxis-auto-typography-small-line-height-sm: var(--perxis-auto-markers-marker-tooltip-line-height-inner);
  --perxis-auto-typography-small-line-height-md: var(--perxis-auto-markers-marker-tooltip-line-height-inner);
  --perxis-auto-typography-small-line-height-lg: var(--perxis-auto-markers-marker-tooltip-line-height-inner);
  --perxis-auto-typography-small-line-height-xl: var(--perxis-auto-markers-marker-tooltip-line-height-inner);
  --perxis-auto-typography-small-line-height-xxl: var(--perxis-auto-markers-marker-tooltip-line-height-inner);
  /* Colors */
  --perxis-auto-markers-marker-tooltip-background-color-inner: var(--perxis-auto-markers-marker-tooltip-background-color, var(--perxis-auto-root-first-color-inner));
  /* End Colors */
  /* Padding */
  --perxis-auto-markers-marker-tooltip-padding-inner: var(--perxis-auto-markers-marker-tooltip-padding, 6px 12px);
  /* End Padding */
  --perxis-auto-tooltip-background-color: var(--perxis-auto-markers-marker-tooltip-background-color-inner);
  --perxis-auto-typography-color-darkest: var(--perxis-auto-markers-marker-tooltip-color-inner);
  --perxis-auto-tooltip-color: var(--perxis-auto-markers-marker-tooltip-color-inner);
}
.perxis-auto-1_16_13-markers__marker-tooltip .ant-5_17_0-tooltip-inner {
  font-family: var(--perxis-auto-markers-marker-tooltip-font-family-inner);
  font-size: var(--perxis-auto-markers-marker-tooltip-font-size-inner);
  font-weight: var(--perxis-auto-markers-marker-tooltip-font-weight-inner);
  line-height: var(--perxis-auto-markers-marker-tooltip-line-height-inner);
  text-transform: var(--perxis-auto-markers-marker-tooltip-text-transform-inner);
  letter-spacing: var(--perxis-auto-markers-marker-tooltip-letter-spacing-inner);
  padding: var(--perxis-auto-markers-marker-tooltip-padding-inner);
}

.perxis-auto-1_16_13-markers__more-list {
  --perxis-auto-markers-more-list-font-family-inner: var(--perxis-auto-markers-more-list-font-family, var(--perxis-auto-root-typography-super-small-font-family-inner));
  --perxis-auto-markers-more-list-font-size-inner: var(--perxis-auto-markers-more-list-font-size, var(--perxis-auto-root-typography-super-small-font-size-xxl-inner));
  --perxis-auto-markers-more-list-line-height-inner: var(--perxis-auto-markers-more-list-line-height, 2);
  --perxis-auto-markers-more-list-font-weight-inner: var(--perxis-auto-markers-more-list-font-weight, var(--perxis-auto-root-typography-super-small-font-weight-inner));
  --perxis-auto-markers-more-list-type-inner: var(--perxis-auto-markers-more-list-type, "—");
  list-style: none;
  margin: 0;
  padding-left: 1em;
}
.perxis-auto-1_16_13-markers__more-list > li {
  font-family: var(--perxis-auto-markers-more-list-font-family-inner);
  font-size: var(--perxis-auto-markers-more-list-font-size-inner);
  font-weight: var(--perxis-auto-markers-more-list-font-weight-inner);
  line-height: var(--perxis-auto-markers-more-list-line-height-inner);
}
.perxis-auto-1_16_13-markers__more-list > li:before {
  display: inline-block;
  content: var(--perxis-auto-markers-more-list-type-inner);
  width: 1em;
  margin-left: -1em;
  margin-right: 0.25em;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
